import { Component, input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [],
  templateUrl: './avatar.component.html',
})
export class AvatarComponent {
  readonly src = input('');
  readonly alt = input('Avatar');
  readonly size = input<'sm' | 'md' | 'lg'>('md');
  readonly customClasses = input('');

  get avatarClasses(): string {
    const sizeClasses = {
      sm: 'w-8 h-8',
      md: 'w-10 h-10',
      lg: 'w-12 h-12',
    };

    return `rounded-full border-2 border-white ${sizeClasses[this.size()]} ${this.customClasses()}`;
  }
}
